"use client";

import React from "react";
import { motion } from "framer-motion";
import Image from "next/image";

export default function OdooHero() {
  return (
    <section className="relative flex items-center min-h-[70vh] pt-12 pb-20 px-6 sm:px-12 lg:px-24 z-10">
      <div className="container mx-auto grid lg:grid-cols-2 gap-12 items-center -mt-10">
        
        {/* Hero Content */}
        <motion.div 
          className="z-10"
        >
          <h1 className="text-xl sm:text-2xl lg:text-4xl font-extrabold leading-tight mb-4 text-white uppercase tracking-tighter">
            Certified Odoo Partner — <span className="text-[#f1833b]">Implement, Customise</span> & Scale!
          </h1>
          <p className="text-xs sm:text-sm text-[#ccc] mb-8 max-w-xl leading-relaxed">
            Trusted By 300+ Businesses Globally, Across 10+ Industries - Solar, Textile, Manufacturing & Beyond. We transform complex workflows into simple, automated solutions.
          </p>
          <div className="flex flex-wrap gap-4">
            <motion.a
              whileTap={{ scale: 0.98 }}
              href="/contact"
              className="group inline-flex items-center gap-2 px-6 py-2.5 bg-[#f1833b] text-black font-bold rounded-full transition-all shadow-lg hover:bg-[#ef7b2f] hover:shadow-[#f1833b]/20"
            >
              <span className="text-[10px] uppercase tracking-wider">Book A Free Consultation</span>
              <span className="text-base transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1">↗</span>
            </motion.a>
          </div>
        </motion.div>

        {/* Hero Image */}
        <motion.div
          className="flex justify-center items-center relative"
        >
          <Image
            src="/assets/img/odoo/odoo-hero.webp"
            alt="Odoo implementation service"
            width={650}
            height={450}
            priority
            className="w-full max-w-[650px] h-auto drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)]" 
          />
        </motion.div>
      </div>
    </section>
  );
}
